var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillChildren(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22C21.0899 22 24 19.0899 24 15.5C24 11.9101 21.0899 9 17.5 9C13.9101 9 11 11.9101 11 15.5C11 19.0899 13.9101 22 17.5 22Z",
    stroke: "url(#paint0_linear_1370_26340)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39V55.9635C25 57.8297 24.2098 59.6194 22.8033 60.939C21.3968 62.2587 19.4891 63 17.5 63V63C15.5109 63 13.6032 62.2587 12.1967 60.939C10.7902 59.6194 10 57.8297 10 55.9635V39",
    stroke: "url(#paint1_linear_1370_26340)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0025 39.0338L63 54.1802L61.0025 56.6802C61.054 58.5642 60.3983 60.3929 59.1793 61.7651C57.9603 63.1374 56.2774 63.9411 54.5 64V64C52.7235 63.9412 51.0418 63.137 49.8245 61.7645C48.6071 60.3919 47.9538 58.5631 48.0081 56.6802L46 54.4279L48.0081 39",
    stroke: "url(#paint2_linear_1370_26340)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46C33 27.25 22.8113 26 22.8113 26C19.4151 29.75 17.717 29.575 17.717 29.575H18.283C18.283 29.575 16.5849 29.75 13.1887 26C13.1887 26 3 27.25 3 46",
    stroke: "url(#paint3_linear_1370_26340)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46C69 27.25 58.8113 26 58.8113 26C55.4151 29.75 53.717 29.575 53.717 29.575H54.283C54.283 29.575 52.5849 29.75 49.1887 26C49.1887 26 39 27.25 39 46",
    stroke: "url(#paint4_linear_1370_26340)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9541 21C49.9541 21 45.8763 9 54.5813 9C63.2862 9 58.8898 21 58.8898 21",
    stroke: "url(#paint5_linear_1370_26340)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1370_26340",
    x1: 12.8685,
    y1: 9.55849,
    x2: 20.4622,
    y2: 18.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1370_26340",
    x1: 12.156,
    y1: 40.0311,
    x2: 25.5153,
    y2: 49.5416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1370_26340",
    x1: 48.4435,
    y1: 40.074,
    x2: 62.7028,
    y2: 51.1186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1370_26340",
    x1: 7.31202,
    y1: 26.8592,
    x2: 17.5844,
    y2: 44.4104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1370_26340",
    x1: 43.312,
    y1: 26.8592,
    x2: 53.5844,
    y2: 44.4104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1370_26340",
    x1: 50.5811,
    y1: 9.51553,
    x2: 57.6435,
    y2: 16.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillChildren);
export default __webpack_public_path__ + "static/media/bill-children.dddedf3a.svg";
export { ForwardRef as ReactComponent };